<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      ref="standAloneVehicleList"
    :headers="header"
    :get-data-func="getStandAloneVehicles"
    @click:row="getDetails($event.item)"
    title-text="独立执行车辆列表"
    clickable>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-tooltip left>
            <v-btn @click="unbindVehicleConfirm(item)" slot="activator" icon>
              <v-icon small>$vuetify.icons.delete</v-icon>
            </v-btn>
            <span>解除独立执行</span>
          </v-tooltip>
        </td>
      </template>
    </l-data-table>
    <v-dialog max-width="500px" persistent scrollable v-model="addFlag">
      <v-layout column>
        <v-card class="pa-3">
          <v-card-title>
            <h3>请输入要添加车辆信息</h3>
            <v-spacer></v-spacer>
            <v-btn icon @click="addFlag=false">
              <v-icon>$vuetify.icons.close</v-icon>
            </v-btn>
          </v-card-title>
          <v-form ref="addVehicleForm">
            <l-plate-picker v-model="plate"></l-plate-picker>
          </v-form>
          <v-layout justify-center>
            <v-btn class="primary" @click="addStandVehicle(plate)" :loading="loading">确定</v-btn>
          </v-layout>
        </v-card>
      </v-layout>
    </v-dialog>
    <l-fixed-btn
      @click="addFlag=true"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
  import {time} from '../../../ladmin/utils/time'
    import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
  import LPlatePicker from "../../../components/LPlatePicker";
    export default {
        name: "aloneVehicleList",
      components: {LPlatePicker, LDataTable},
      data(){
          return {
            header:[
              {text:'车牌号码',value:'id',align:'left',sortable:false},
              {text:'创建时间',value:'creationTime',align:'left',sortable:true,f:(v)=>time.stringify(v)},
              {text:'',value:'',align:'left',sortable:false}
            ],
            vehicleList:[
              {
                plateNumber:'京Q11111',
                creationTime:'2019-11-11',
                ruleNum:"10"
              },
              {
                plateNumber:'京Q11111',
                creationTime:'2019-11-11',
                ruleNum:"10"
              },
              {
                plateNumber:'京Q11111',
                creationTime:'2019-11-11',
                ruleNum:"10"
              },
            ],
            plate:'',
            addFlag:false,
            loading:false
          }
        },
      methods:{
        async getStandAloneVehicles ({pagination, sortStack, filterItems = [], search}) {
          try{
            let res = await this.$store.dispatch('passControl/getStandAloneVehicles',{pagination,plate:search})
            if(res.data.status+''==='1'){
              return {items:res.data.data.content,amount:res.data.data.totalElements}
            }
          }catch (e) {
            console.log(e)
          }
        },
        async unbindVehicleConfirm(item){
          let {res, close} = await this.$L.confirm({
            title: '解除确认',
            text: '确认解除该车辆的独立执行权限?\n车牌：' + item.id
          })
          if (res) {
            try {
              await this.unbindVehicle(item)
            }
            catch (e) {
              this.$L.alert('error', e.message)
            }
          }
          close()
        },
        async unbindVehicle(item){
          let vehicle = {
            plate:item.id
          }
          let res = await this.$store.dispatch('pass/setStandalone',{vehicle:vehicle,value:false})
          this.$L.alert('success',{message:'解除成功'})
          this.$refs.standAloneVehicleList.refresh()
        },
        async addStandVehicle(id){
          if(this.$refs.addVehicleForm.validate()){
            let vehicle = {
              plate:id
            }
            this.loading = true
            let res = await this.$store.dispatch('pass/setStandalone',{vehicle:vehicle,value:true})
            this.loading = false
            this.plate = ""
            this.$L.alert('success',{message:'添加成功'})
            this.addFlag = false
            this.$refs.standAloneVehicleList.refresh()
          }else{
            this.$L.alert('error',{message:'车牌数据不合法'})
          }
        },
        getDetails(item){
          let selectionString = document.getSelection().toString()
          if (!selectionString) {
            this.$router.push({
              name: 'vehicleRuleDetailsBox',
              query: {
                id: item.id,
              }
            })
          }
        }
      }
    }
</script>

<style scoped>

</style>
